import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { trackError } from "./utils/errorTracker";
import reportWebVitals from "./reportWebVitals";
import "react-camera-media-stream/dist/index.css";
import ReactGA from "react-ga4";

ReactGA.initialize([
  {
    trackingId: "G-KRNL7S0KEH",
  },
]);

// Global JS error tracking
window.addEventListener("error", (event) => {
  trackError({
    type: "js_error_global",
    message: event.message,
    source: event.filename,
    line: event.lineno,
    col: event.colno,
  });
});

window.addEventListener("unhandledrejection", (event) => {
  trackError({
    type: "js_promise_error",
    message: String(event.reason),
  });
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
